<template>
  <modal name="renew-modal" width="280px" height="230px" class="renew-modal" :pivotY="0.4">
    <div class="title">{{ order.productName }}</div>
    <div class="input-box">
      <!-- <cube-input class="cube-input" placeholder="请输入续费时长(月)" type="number"></cube-input> -->
      <number-input class="cube-input" placeholder="请输入续费时长(月)" :controls="false" :precision="0" :max="maxMonth" :min="1" v-model="monthDuration"></number-input>
      <span>月</span>
    </div>
    <div class="money">{{`总收费：￥${price}`}}</div>
    <div class="btn-box">
      <div @click="cancel">取消</div>
      <div @click="confirmRenew">确定续费</div>
    </div>
  </modal>
</template>

<script>
import VueNumericInput from 'vue-numeric-input';
import { priceMixin } from 'common/js/price-mixin';
import calcPrice from 'common/js/price-calculator';

export default {
  mixins: [priceMixin],
  components: {
    NumberInput: VueNumericInput
  },
  props: {
    order: {
      default() {
        return {}
      },
      type: Object,
    }
  },
  data() {
    return {
      monthDuration: null,
    }
  },
  computed: {
    maxMonth() {  // 此人最大能再续费的月份，默认36
      return 60 - this.order.usedMonthNum - this.order.rentFreeDuration;
    },
    price() {
      return calcPrice(this.order, this.monthDuration, 2);
    }
  },
  methods: {
    cancel() {
      this.$modal.hide('renew-modal');
    },
    confirmRenew() {
      this.$emit('confirm', this.order.id, this.monthDuration, this.price);
      this.$modal.hide('renew-modal');
    },
    fixPrice(price) {
      return Number(price.toFixed(2))
    }
  }
}
</script>

<style lang="scss">
.renew-modal {
  .v--modal {
    padding: 20px;
    border-radius: 10px;
  }
  .title {
    font-size: 17px;
    line-height: 24px;
    margin-bottom: 15px;
  }
  .input-box {
    width: 100%;
    position: relative;
    > span {
      position: absolute;
      right: 15px;
      top: 14px;
      font-size: 14px;
    }
  }
  .cube-input {
    width: 100%!important;
    height: 40px;
    .numeric-input {
      width: 100%;
      height: 40px;
      background: #F7F7F7;
      padding-right: 40px;
      border-color: #E6E6E6;
      outline: none;
      -webkit-appearance: none;
    }
  }
  .money {
    font-size: 14px;
    color: #666;
    margin-top: 15px;
  }
  .btn-box {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    height: 50px;
    width: 100%;
    line-height: 50px;
    text-align: center;
    border-top: 1px solid #E5E5E5;
    > div:first-child {
      width: 50%;
      border-right: 1px solid #E5E5E5;
    }
    > div:nth-child(2) {
      width: 50%;
      color: #f90;
    }
  }
}

</style>


